<template>
  <div class="container">
    <HeaderComponent :menu-id="1"></HeaderComponent>

    

    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.home-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 60px;
}

// 搜索框
.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;

  .search-label {
    background: #947c44;
    color: #fff;
    padding: 10px 28px;
    border-radius: 24px 0 0 24px;
  }

  .search-input {
    height: 40px;
    padding: 0 12px;
    border: none;
    outline: none;
  }

  .search-icon {
    background: #fff;
    padding: 0 16px 0 4px;
    border-radius: 0 24px 24px 0;
    height: 40px;
    display: flex;
    align-items: center;
  }
}

// 顶部两个卡片
.card-group {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;

  .info-card {
    flex: 1;
    background: #a88e54;
    border-radius: 12px;
    text-align: center;
    padding: 48px 20px;
    color: #fff;

    h2 {
      font-size: 32px;
      font-weight: normal;
      margin: 0 0 24px;
    }

    p {
      font-size: 18px;
      line-height: 1.6;
      margin-bottom: 32px;
    }

    .card-btn {
      border: none;
      background: #fff;
      color: #333;
      padding: 8px 24px;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}

// 下半部分
.bottom-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;

  .left-part {
    text-align: center;

    .red-tag {
      border: 2px solid #b82626;
      color: #b82626;
      display: inline-block;
      padding: 6px 20px;
      border-radius: 6px;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .coin-img-box img {
      width: 220px;
    }
  }

  .divider {
    width: 1px;
    height: 160px;
    background: #cccccc;
  }

  .right-part {
    h3 {
      font-size: 24px;
      color: #222;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: #947c44;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      text-align: center;
      font-size: 18px;
      line-height: 1.8;
      margin: 16px 0 24px;
    }

    .red-btn {
      border: 2px solid #b82626;
      color: #b82626;
      background: transparent;
      padding: 8px 24px;
      border-radius: 6px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>